import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import Typography from '@material-ui/core/Typography'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Card, CardContent, Divider, CircularProgress } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { useTipoExameService } from 'hooks/useTipoExameService'
import useRouter from 'utils/useRouter'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { uniqueId } from 'lodash'

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {},
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  inner: {
    minWidth: 400,
  },
  botoes: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(4),
  },
  actions: {
    justifyContent: 'flex-end',
  },
  arrowForwardIcon: {
    marginLeft: theme.spacing(1),
  },
}))

export const DetailPanel = (props) => {
  const { className, id, ...rest } = props
  const classes = useStyles()
  const tipoExameService = useTipoExameService()
  const [dados, setDados] = useState([])
  const [carregando, setCarregando] = useState(false)
  const dispatch = useDispatch()
  const router = useRouter()
  moment.locale('pt-br', localization)

  useEffect(() => {
    const fetchDados = async () => {
      const tipoExame = await tipoExameService.listarTipoExameDetalhadoAsync(id, setCarregando)
      setDados(tipoExame)
    }

    fetchDados()
  }, [dispatch, id, router])

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <Divider />
      <CardContent className={classes.content}>
        {carregando ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          <PerfectScrollbar>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="h6">Nome do exame:</Typography>
                  </TableCell>
                  <TableCell align="left">{dados.nome}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="h6">Setores que realizam o exame:</Typography>
                  </TableCell>
                  <TableCell align="left">
                    {dados.setResps
                      ? dados.setResps.map((item) => (
                          <li key={uniqueId()}>
                            {item.nome} / {item.divisao?.sigla} / {item.divisao?.regional.sigla}
                          </li>
                        ))
                      : null}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="h6">Trata-se de exame do tipo agendado</Typography>
                  </TableCell>
                  <TableCell align="left">{dados.agendado ? <Typography>Sim</Typography> : <Typography>Não</Typography>}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="h6">Quesitos padrão:</Typography>
                  </TableCell>
                  <TableCell align="left">{dados.quesitos ? dados.quesitos.map((item) => <li key={uniqueId()}>{item.quesito}</li>) : null}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="h6">Seções do documento</Typography>
                  </TableCell>
                  <TableCell>{dados?.secoes?.length ? dados.secoes.map((item) => <li key={uniqueId()}>{item.titulo}</li>) : 'Nenhuma seção cadastrada para esse tipo de exame'}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </PerfectScrollbar>
        )}
      </CardContent>
    </Card>
  )
}
